var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.orders),function(item){return _c('p',{key:item.id,attrs:{"value":item.id}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Purchases/Freight/FreightOrders.vue